module.exports = __webpack_public_path__ + "media/images/documents/other-format-d079076e7444bfdf36057d47e4cd1fdb.jpg";